const About = () => {
  return (
    <div className='text-center'>
      <h1>About InScreen</h1>
      <p>
        InScreen is a front end digital signage app created by{' '}
        <a
          href='https://www.inventivedesign.co.uk/'
          target='_blank'
          rel='noreferrer'
        >
          Inventive
        </a>
      </p>
      <p>
        You can manage your signage at{' '}
        <a href='https://inscreen.it/' target='_blank' rel='noreferrer'>
          inscreen.it
        </a>
      </p>
    </div>
  )
}

export default About
